import React, {
    PropTypes,
} from 'react';
import {InputGroup, Alert, FormControl, Panel, Button} from 'react-bootstrap';

class ActEmail extends React.Component {
    static propTypes = {
        act: PropTypes.object.isRequired,
        current: PropTypes.object.isRequired,
        onSend: PropTypes.func.isRequired,
        changeEmail: PropTypes.func.isRequired
    };

    getDateString(date) {
        const dt = (('0' + date.getDate()).slice(-2));
        const month = (('0' + (date.getMonth() + 1)).slice(-2));

        return dt + '.' + month + '.' + date.getFullYear();
    }

    render() {
        const {act, current, onSend, changeEmail} = this.props;

        return (
            <Panel header="Надіслати акт на e-mail">
                <form>
                    <InputGroup className="mb15">
                        <InputGroup.Addon>@</InputGroup.Addon>
                        <FormControl type="email" value={act.email} onChange={(e) => changeEmail(e.target.value)}/>
                    </InputGroup>
                    <Button block bsStyle="success mb15" onClick={(e) => {
                        e.preventDefault();
                        onSend(act, current);
                    }}>Надіслати</Button>
                    {act.text ? <Alert bsStyle="success"><p>{act.text}</p></Alert> : ''}
                    {act.emailError ? <Alert bsStyle="danger"><p>{act.emailError}</p></Alert> : ''}
                </form>
            </Panel>
        );
    };
}

export default ActEmail;



/** WEBPACK FOOTER **
 ** ./src/modules/finance/ActEmail.js
 **/